function LandingView({
  isDragging,
  onOpenFile
}: {
  isDragging: boolean
  onOpenFile: () => void
}) {
  return (
    <div className={`landing${isDragging ? ' landing--dragging' : ''}`}>
      <div className="landing-content">
        <h1 className="landing-title">Super Metroid Save Editor</h1>
        <p className="landing-subtitle">
          {isDragging
            ? 'Release to load file'
            : 'Drop an .srm file anywhere on this page'}
        </p>
        <div className="landing-divider">
          <span>or</span>
        </div>
        <button className="browse-btn" onClick={onOpenFile}>
          Browse for file
        </button>
      </div>
    </div>
  )
}

export default LandingView
